import { useState } from "react";

/** Un seul composant partagé : même lecture et même repli dans les deux espaces. */
export function PartenaireVideoPlayer({ url, title }: { url: string; title: string }) {
  const [failed, setFailed] = useState(false);
  return (
    <div className="w-full min-w-0 space-y-3" data-testid="partenaire-video-player">
      {failed ? (
        <p role="status" className="text-sm text-muted-foreground">
          Ce format ne peut pas être lu dans ce navigateur — téléchargez la vidéo.
        </p>
      ) : (
        <video
          controls preload="metadata" playsInline src={url} aria-label={title}
          onError={() => setFailed(true)}
          className="block w-full max-w-full rounded-lg bg-black"
          style={{ maxHeight: "60vh" }}
          data-testid="partenaire-video"
        />
      )}
      <a href={url} target="_blank" rel="noopener noreferrer" download
        className="inline-flex text-sm font-medium text-primary underline"
        data-testid="partenaire-video-download">
        Télécharger
      </a>
    </div>
  );
}
